/**
 * KiekkoKingi section controller: simulator-hero
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
        const rootId = kkScript.dataset.rootId;
        const sectionId = kkScript.dataset.sectionId;
        const destroy = (root) => {
          if (!root || !root.__kiekkokingiSimulatorCleanup) return;
          root.__kiekkokingiSimulatorCleanup.forEach((cleanup) => cleanup());
          root.__kiekkokingiSimulatorCleanup = null;
          root.removeAttribute('data-simulator-initialized');
        };
  
        const init = (root) => {
          if (!root || root.hasAttribute('data-simulator-initialized')) return;
          root.setAttribute('data-simulator-initialized', 'true');
          const cleanup = [];
          const video = root.querySelector('[data-simulator-video]');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const autoplay = root.dataset.videoAutoplay === 'true';
          const pauseReducedMotion = root.dataset.pauseReducedMotion === 'true';
          let wantsPlayback = autoplay;
  
          const reconcileVideo = () => {
            if (!video) return;
            const useFallback = pauseReducedMotion && reducedMotion.matches;
            root.classList.toggle('is-reduced-motion', useFallback);
            if (useFallback || document.hidden) {
              video.pause();
              return;
            }
            if (wantsPlayback) {
              const promise = video.play();
              if (promise && typeof promise.catch === 'function') promise.catch(() => {});
            }
          };
  
          const onPlay = () => { wantsPlayback = true; };
          const onPause = () => {
            const pausedByEnvironment = document.hidden || (pauseReducedMotion && reducedMotion.matches);
            if (!pausedByEnvironment) wantsPlayback = false;
          };
          const onVisibility = () => reconcileVideo();
          const onReducedMotion = () => reconcileVideo();
  
          if (video) {
            video.addEventListener('play', onPlay);
            video.addEventListener('pause', onPause);
            document.addEventListener('visibilitychange', onVisibility);
            if (typeof reducedMotion.addEventListener === 'function') {
              reducedMotion.addEventListener('change', onReducedMotion);
            } else {
              reducedMotion.addListener(onReducedMotion);
            }
            reconcileVideo();
            cleanup.push(() => video.removeEventListener('play', onPlay));
            cleanup.push(() => video.removeEventListener('pause', onPause));
            cleanup.push(() => document.removeEventListener('visibilitychange', onVisibility));
            cleanup.push(() => {
              if (typeof reducedMotion.removeEventListener === 'function') {
                reducedMotion.removeEventListener('change', onReducedMotion);
              } else {
                reducedMotion.removeListener(onReducedMotion);
              }
            });
            cleanup.push(() => video.pause());
          }
  
          const onBlockSelect = (event) => {
            if (!event.detail || !event.detail.blockId) return;
            const fact = root.querySelector(`[data-simulator-fact="${event.detail.blockId}"]`);
            if (!fact) return;
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            fact.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
          };
          document.addEventListener('shopify:block:select', onBlockSelect);
          cleanup.push(() => document.removeEventListener('shopify:block:select', onBlockSelect));
          root.__kiekkokingiSimulatorCleanup = cleanup;
        };
  
        const onSectionLoad = (event) => {
          if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;
          init(document.getElementById(rootId));
        };
        const onSectionUnload = (event) => {
          if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;
          const root = event.target.querySelector('[data-kiekkokingi-simulator-hero]') || document.getElementById(rootId);
          destroy(root);
          document.removeEventListener('shopify:section:load', onSectionLoad);
          document.removeEventListener('shopify:section:unload', onSectionUnload);
        };
  
        init(document.getElementById(rootId));
        document.addEventListener('shopify:section:load', onSectionLoad);
        document.addEventListener('shopify:section:unload', onSectionUnload);
      })();
})();